import I18n from 'app/i18n';

const WithZeroDays = ({diffDays}) => I18n.t('days', {count: diffDays});

export default WithZeroDays;
